<template>

  <v-dialog
    v-model="show"
    persistent
    max-width="470">
    <v-card>
         <v-toolbar dense dark color="secondary">NEW DELIVERY<v-spacer/><v-icon @click="emitToParent('cancel')">mdi-close</v-icon> </v-toolbar>
        <v-card-text>
             <v-form
                ref="form"
                class="mt-4"
                v-model="valid"
                lazy-validation
              >
                <v-text-field
                v-model="dr.number"
                label="D.R #"
                :rules="textRules"
                prepend-icon="mdi-file"
                dense
                outlined
                required
                ></v-text-field>
                <v-autocomplete
                 prepend-icon="mdi-account"
                   v-model="dr.salesman"
                label="Select Salesman"
                :items="GET_SALESMEN()"
                item-text="label"
                item-value="id"
                :rules="textRules"
                dense
                outlined
                required
                />
                
                <v-autocomplete
                  v-model="dr.truck"
                  prepend-icon="mdi-truck"
                  label="Truck"
                  :items="$store.state.trucks"
                  item-text="name"
                  item-value="id"
                  dense
                  outlined
                />

                <v-autocomplete
                  v-model="dr.driver"
                    prepend-icon="mdi-card-account-details-outline"
                  label="Driver"
                  :items="DRIVERS"
                  item-text="fullname"
                  item-value="id"
                  dense
                  outlined
                />

             </v-form>
        </v-card-text>
        <v-card-actions>
                <v-btn color="warning" small  text @click="emitToParent('close')">CLOSE</v-btn>
            <v-spacer></v-spacer>
            <v-btn  small color="success"  depressed  @click="validate()">{{BTN_TEXT}}</v-btn>
        </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    show: {
        type: Boolean,
        default: false
    },
    state: {
        type: String,
        default: "new"
    }
  },
  data: () => ({
      valid: true,
      textRules: [
        v => !!v || 'Field is required'
      ],
       dr:{},
        salesman:{}
  }),
  computed: {
      BTN_TEXT() {
          if(this.state == 'new')
            return "ADD"
         else 
            return "SAVE"
      },
      DRIVERS() {
        if(this.$store.state.drivers == undefined || this.$store.state.drivers == null) {
          return []
        }
        var arr = this.$store.state.drivers.reduce((res, item)=>{
            if(item.status=='active') {
              res.push(item)
            }
            return res
        },[])
        return arr
      }
  },
  watch: {
      show(v){
        if(v){this.dr = {}}
      }
  },
  methods: {
      validate () {
        if (this.$refs.form.validate()) {
          this.dr.status = 'on-process'
          this.Save()
        }
      },
    emitToParent (action) {
       this.$emit('DialogEvent', {action: action, po:this.po})
    },
    Save() {
      this.dr.status = 'on-process'
        this.$http.post("delivery/add", this.dr).then(response => {
          console.log(response.data)
            this.GET_RESPONSE(response)
           this.$emit('DialogEvent', {action: "close"})
          }).catch(e => {
            console.log(e.data)
        })
    }
  }
}
</script>
